// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1GSvC","col":"styles_col__3GEux","fulfillmentStatus":"styles_fulfillmentStatus__2YMLq","emailCol":"styles_emailCol__1jMe2"};